<template>
  <b-card>
    <b-form
      class="mt-2"
      @submit.stop.prevent="save"
    >
      <b-row>
        <b-col sm="12">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="tt.email"
              name="email"
              placeholder="Email"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Username"
            label-for="account-username"
          >
            <b-form-input
              v-model="tt.name"
              name="account-username"
              placeholder="Nombre Completo"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Telefono"
            label-for="account-company"
          >
            <b-form-input
              v-model="tt.phone"
              name="company"
              placeholder="Telefono"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            v-if="!loading"
            variant="primary"
            type="submit"
            block
          >
            <feather-icon
              icon="SaveIcon"
              class="mr-25"
            />
            Guardar
          </b-button>
          <b-button
            v-else
            block
            disabled
            variant="primary"
          >
            Procesando...
            <b-spinner small />
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BSpinner,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
} from "bootstrap-vue"
import { ref } from "@vue/composition-api"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"

export default {
  components: {
    BButton,
    BSpinner,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      tt: {
        idusuario: null,
        email: "",
        name: "",
        phone: "",
      },
      loading: false,
    }
  },
  created() {
    this.search()
  },
  methods: {
    search() {
      this.$http
        .get(`/user/${this.userData.id}`)
        .then((response) => {
          this.tt.idusuario = response.data.idusuario
          this.tt.email = response.data.email
          this.tt.name = response.data.name
          this.tt.phone = response.data.phone
        })
        .catch((error) => {
          console.log(error)
        })
    },
    save() {
      this.loading = true
      this.$http
        .put(`=/user/${this.userData.id}`, {
          name: this.tt.name,
          phone: this.tt.phone,
        })
        .then((response) => {
          this.loading = false
          this.showToast(
            "Datos actualizados correctamente",
            "success",
            "UserIcon",
          )
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
    },
    showToast(message, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          variant,
          icon,
        },
      })
    },
  },
}
</script>
